import { render, staticRenderFns } from "./TaskPopup.vue?vue&type=template&id=6a8f3b1d&scoped=true&"
import script from "./TaskPopup.vue?vue&type=script&lang=js&"
export * from "./TaskPopup.vue?vue&type=script&lang=js&"
import style0 from "./TaskPopup.vue?vue&type=style&index=0&id=6a8f3b1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f3b1d",
  null
  
)

export default component.exports